import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import type {RootState} from "../Store";
import {setCart} from "../redux/Order";
import {setCredit} from "../redux/User";
import Loader from "../components/Loader";
import {addActiveTransaction, addTransaction, clearData} from "../redux/Transaction";
import Button from "../components/Button";
import TransactionServiece, {Webhook} from "../services/TransactionService";
import {useNavigate} from "react-router-dom";
import PayByStripeButton from "../components/Stripe/PayByStripeButton";

export default function App() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const data = useSelector((state: RootState) => state);
    const [isLoading, setIsLoading] = useState(false);
    const [paymentLink, setPaymentLink] = useState("");
    const [test, setTest] = useState<Webhook | undefined>(undefined);

    useEffect(() => {

        if (localStorage.getItem("order")) {

            let order = localStorage.getItem("order");
            if (order === null) {
                order = "";
            }

            dispatch(setCart(JSON.parse(order)));

        }

    }, []);

    useEffect(() => {

        if (data.order.totalPrice > 0) {
            getPaymentInitent();
        }

    }, [data.order, test]);

    const getPaymentInitent = async () => {
        fetch(process.env.REACT_APP_API_URL + "/paymentLink", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
                price: data.order.totalPrice,
                product: data.order.items[0],
                company_code: process.env.REACT_APP_COMPANY,
                success_url: process.env.REACT_APP_URL + "/stripe/success",
                cancel_url: process.env.REACT_APP_URL + "/stripe",
            }),
        })
        .then((res) => res.json())
        .then((data) => {
            setPaymentLink(data.paymentLink.url);
            localStorage.setItem("paymentBackTrackId", data.paymentLink.id)
        })
    };

    const clearAndMove = () => {
        localStorage.setItem("paymentBackTrackId","");
        localStorage.setItem("order","");
        navigate("/order");
    }

    /*ONLY FOR TEST */

    const testSubmitPayment = async () => {

        setIsLoading(true);

        let order = data.order;
        let transaction: any = {};

        transaction.stripe_id = 111;
        transaction.amount = 100;
        transaction.totalPrice = order.totalPrice;
        transaction.tax = order.totalTax;
        transaction.unitPrice = order.items[0].price;
        transaction.pour_id = order.items[0].id;
        transaction.qty = order.items[0].qty;
        transaction.customer_id = localStorage.getItem("customer_id");
        transaction.company_code = process.env.REACT_APP_COMPANY;

        const dataPromise = await TransactionServiece.addTransaction(transaction);

        dispatch(addTransaction(dataPromise));
        dispatch(addActiveTransaction(dataPromise));
        clearAndMove();

    }

    const useCreditSubmitPayment = async () => {

        setIsLoading(true);

        let order = data.order;
        let transaction: any = {};

        transaction.stripe_id = -1;
        transaction.amount = order.totalPrice;
        transaction.totalPrice = order.totalPrice;
        transaction.tax = order.totalTax;
        transaction.unitPrice = order.items[0].price;
        transaction.pour_id = order.items[0].id;
        transaction.qty = order.items[0].qty;
        transaction.customer_id = localStorage.getItem("customer_id");
        transaction.company_code = process.env.REACT_APP_COMPANY;

        dispatch(setCredit(-order.totalPrice));

        const dataPromise = await TransactionServiece.addTransaction(transaction);

        dispatch(addTransaction(dataPromise));
        dispatch(addActiveTransaction(dataPromise));
        clearAndMove();

    }

    return (
        <div className="p-6">
            <div className="space-y-6">
                <h4 className="text-2xl font-semibold text-gray-900 ">
                    Order summary
                </h4>
                {data.order.items &&
                    data.order.items.map((employee: any, index: number) => {
                        return (
                            <>
                                <div className="space-y-4" key={index}>
                                    <div className="space-y-2">
                                        <dl className="flex items-center justify-between gap-4">
                                            <dt className="text-gray-500 ">
                                                {employee.name} ({(employee.qty).toFixed(0)} {employee.unitName})
                                            </dt>
                                            <dd className="text-base font-medium text-gray-900 ">
                                                ${employee.price.toFixed(2)}
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                            </>
                        );
                    })}

                {data.order.totalPrice > 0 && (
                    <>
                        <dl className="flex items-center justify-between gap-4">
                            <dt className="text-gray-500 ">Tax {data.cart.detail.tax}% :{" "}</dt>
                            <dd className="text-base font-medium text-gray-900 ">
                                {data.order.totalTax.toFixed(2)}
                            </dd>
                        </dl>
                    </>
                )}

                <dl className="flex items-center justify-between gap-4 border-t border-gray-200 pt-2 dark:border-gray-700">
                    <dt className="text-lg font-bold text-gray-900 ">
                        Total
                    </dt>
                    <dd className="text-lg font-bold text-gray-900 ">
                        ${data.order.totalPrice.toFixed(2)}
                    </dd>
                </dl>

            </div>

            {process.env.REACT_APP_CREDIT == "ON" && data.user.credit > 0 && data.user.credit > data.order.totalPrice &&

                <>
                    <Button style="primary" className={"mt-3 credit-bg"} type="button" onClick={useCreditSubmitPayment}> <i className="fa-solid fa-coins mr-2"></i> Use Credit</Button>
                </>

            }

            {process.env.REACT_APP_MODE == "TEST" &&

                <>
                    <Button style="primary" className={"mt-3"} type="button" onClick={testSubmitPayment}>{isLoading ?
                        <Loader/> : "TEST Pay"} </Button>
                </>

            }

            <>

                {paymentLink !== "" && (
                    <>
                        <PayByStripeButton href={paymentLink}/>
                    </>
                )}

                {paymentLink === "" && <Loader/>}

            </>


        </div>
    );
}
